import SearchBoxContainer from './searchBoxContainer';

export default SearchBoxContainer;
